import * as React from "react";
const IconCenterAlign = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M55.2 2H8.8C5.1 2 2 5.1 2 8.8v46.4C2 58.9 5.1 62 8.8 62h46.4c3.7 0 6.8-3.1 6.8-6.8V8.8C62 5.1 58.9 2 55.2 2M60 55.2c0 2.6-2.2 4.8-4.8 4.8H8.8C6.2 60 4 57.8 4 55.2V8.8C4 6.2 6.2 4 8.8 4h46.4C57.8 4 60 6.2 60 8.8z" />
    <path d="M32 23.9c.6 0 1-.4 1-1v-9.7c0-.6-.4-1-1-1s-1 .4-1 1v9.7c0 .5.4 1 1 1M32 40.1c-.6 0-1 .4-1 1v9.7c0 .6.4 1 1 1s1-.4 1-1v-9.7c0-.5-.4-1-1-1M21.1 31h-9.7c-.6 0-1 .4-1 1s.4 1 1 1h9.7c.6 0 1-.4 1-1s-.4-1-1-1M52.6 31h-9.7c-.6 0-1 .4-1 1s.4 1 1 1h9.7c.6 0 1-.4 1-1s-.5-1-1-1" />
    <circle cx={32} cy={32} r={2.9} />
  </svg>
);
export default IconCenterAlign;
